import React from 'react';

function WindowsIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.6 24" width="22" height="22" fill="currentColor">
			<g>
				<path d="M0,3.2v8H11.2V1.8Z"/>
				<path d="M12.8,1.6v9.6H25.6V0Z"/>
				<path d="M12.8,12.8v9.6L25.6,24V12.8Z"/>
				<path d="M0,12.8v8l11.2,1.4V12.8Z"/>
			</g>
		</svg>
	);
}

export default WindowsIcon;